import { render, staticRenderFns } from "./ProviderMulti.vue?vue&type=template&id=2e629cc7&"
import script from "./ProviderMulti.vue?vue&type=script&lang=ts&"
export * from "./ProviderMulti.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports